module.exports = __webpack_public_path__ + "static/media/play-button.4910003b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play-button.svg
// module id = 375
// module chunks = 0